import React, { createRef, PureComponent } from "react";
import Swiper from "swiper/bundle";
import { Scene, PointLayer } from "@antv/l7";
import { GaodeMap } from "@antv/l7-maps";
import CountUp from "react-countup";
import { transWord } from "./constant/trans";
import "swiper/swiper.scss";
import "swiper/components/pagination/pagination.scss";
import "swiper/components/navigation/navigation.scss";
import "./App.scss";
import video from "./assets/video.mp4";
import video2 from "./assets/video2.mp4";

// 图片资源上下文：中英文切换时，中文使用原图，英文优先使用 _en 结尾的同名图片（不存在则回退原图）
const imageContext = require.context(
  "./assets/images",
  false,
  /\.(png|jpe?g)$/,
);

const getImage = (lang, file) => {
  // require.context 返回的是模块对象，需解包 default 得到真实地址
  const resolve = (key) => {
    const mod = imageContext(key);
    return mod && mod.default ? mod.default : mod;
  };
  if (lang === "en") {
    const dotIndex = file.lastIndexOf(".");
    const enFile = `${file.slice(0, dotIndex)}_en${file.slice(dotIndex)}`;
    if (imageContext.keys().indexOf(`./${enFile}`) !== -1) {
      return resolve(`./${enFile}`);
    }
  }
  return resolve(`./${file}`);
};

const tabList = [
  {
    tabValue: 1,
    tabLableKey: "strategic",
    tabImage: [43, 44, 42],
  },
  {
    tabValue: 2,
    tabLableKey: "property",
    tabImage: [
      45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62,
      63, 64, 65, 66, 67, 68, 69, 70, 71,
    ],
  },
  {
    tabValue: 3,
    tabLableKey: "oem",
    tabImage: [1, 2, 3, 4, 5, 6, 7, 8, 10, 11, 13, 14, 15, 41, 72, 73, 74],
  },
  {
    tabValue: 4,
    tabLableKey: "platform",
    tabImage: [17, 18, 19],
  },
];

const tabList2 = [
  {
    tabValue: 1,
    tabLableKey: "professional",
    tabImage: [
      {
        value: 21,
        descKey: "q21",
      },
      {
        value: 2,
        descKey: "q2",
      },
      {
        value: 3,
        descKey: "q3",
      },
      {
        value: 4,
        descKey: "q4",
      },
      {
        value: 22,
        descKey: "q22",
      },
      {
        value: 20,
        descKey: "q20",
      },
      {
        value: 1,
        descKey: "q1",
      },
      {
        value: 19,
        descKey: "q19",
      },
    ],
  },
  {
    tabValue: 2,
    tabLableKey: "industry",
    tabImage: [
      {
        value: 5,
        descKey: "q5",
      },
      {
        value: 6,
        descKey: "q6",
      },
      {
        value: 7,
        descKey: "q7",
      },
      {
        value: 8,
        descKey: "q8",
      },
      {
        value: 25,
        descKey: "q25",
      },
      {
        value: 24,
        descKey: "q24",
      },
      {
        value: 23,
        descKey: "q23",
      },
    ],
  },
  {
    tabValue: 3,
    tabLableKey: "patent",
    tabImage: [
      {
        value: 9,
        descKey: "q32",
      },
      {
        value: 10,
        descKey: "q33",
      },
      {
        value: 11,
        descKey: "q34",
      },
      {
        value: 12,
        descKey: "q35",
      },
      {
        value: 13,
        descKey: "q36",
      },
      {
        value: 14,
        descKey: "q37",
      },
      {
        value: 15,
        descKey: "q30",
      },
      {
        value: 16,
        descKey: "q31",
      },
      {
        value: 17,
        descKey: "q31",
      },
      {
        value: 18,
        descKey: "q18",
      },
      {
        value: 26,
        descKey: "q26",
      },
      {
        value: 27,
        descKey: "q27",
      },
      {
        value: 28,
        descKey: "q28",
      },
      {
        value: 29,
        descKey: "q29",
      },
    ],
  },
];

// 业务规模统计数据（与文案一一对应，与语言无关）
const page3StatNums = [160, 3000, 35000, 15000, 730000];

// 站点/城市数据（源自 src/assets/launch_sites.csv，共 34 个城市站点）。
// 数据内联而非运行时 fetch：浏览器禁止 file:// 协议下的 fetch 请求，
// 直接双击打开 index.html 时 fetch 会失败，导致地图圆点和英文城市名不渲染。
const launchCities = [
  { cn: "沈阳市", en: "Shenyang", lng: 123.429092, lat: 41.796768 },
  { cn: "长春市", en: "Changchun", lng: 125.324501, lat: 43.886841 },
  { cn: "哈尔滨市", en: "Harbin", lng: 126.642464, lat: 45.756966 },
  { cn: "北京市", en: "Beijing", lng: 116.405289, lat: 39.904987 },
  { cn: "天津市", en: "Tianjin", lng: 117.190186, lat: 39.125595 },
  { cn: "呼和浩特市", en: "Hohhot", lng: 111.75199, lat: 40.84149 },
  { cn: "银川市", en: "Yinchuan", lng: 106.23248, lat: 38.48644 },
  { cn: "太原市", en: "Taiyuan", lng: 112.549248, lat: 37.857014 },
  { cn: "石家庄市", en: "Shijiazhuang", lng: 114.502464, lat: 38.045475 },
  { cn: "济南市", en: "Jinan", lng: 117.000923, lat: 36.675808 },
  { cn: "郑州市", en: "Zhengzhou", lng: 113.665413, lat: 34.757977 },
  { cn: "西安市", en: "Xi'an", lng: 108.948021, lat: 34.263161 },
  { cn: "武汉市", en: "Wuhan", lng: 114.298569, lat: 30.584354 },
  { cn: "南京市", en: "Nanjing", lng: 118.76741, lat: 32.041546 },
  { cn: "合肥市", en: "Hefei", lng: 117.283043, lat: 31.861191 },
  { cn: "上海市", en: "Shanghai", lng: 121.472641, lat: 31.231707 },
  { cn: "长沙市", en: "Changsha", lng: 112.982277, lat: 28.19409 },
  { cn: "南昌市", en: "Nanchang", lng: 115.892151, lat: 28.676493 },
  { cn: "杭州市", en: "Hangzhou", lng: 120.15358, lat: 30.287458 },
  { cn: "福州市", en: "Fuzhou", lng: 119.306236, lat: 26.075302 },
  {
    cn: "广州市",
    en: "Guangzhou",
    lng: 113.28064,
    lat: 23.125177,
    label: "top",
  },
  { cn: "台北市", en: "Taipei", lng: 121.520076, lat: 25.030724 },
  { cn: "海口市", en: "Haikou", lng: 110.19989, lat: 20.04422 },
  { cn: "南宁市", en: "Nanning", lng: 108.320007, lat: 22.82402 },
  { cn: "重庆市", en: "Chongqing", lng: 106.504959, lat: 29.533155 },
  { cn: "昆明市", en: "Kunming", lng: 102.71225, lat: 25.040609 },
  { cn: "贵阳市", en: "Guiyang", lng: 106.713478, lat: 26.578342 },
  { cn: "成都市", en: "Chengdu", lng: 104.065735, lat: 30.659462 },
  { cn: "兰州市", en: "Lanzhou", lng: 103.83417, lat: 36.06138 },
  { cn: "西宁市", en: "Xining", lng: 101.77782, lat: 36.61729 },
  { cn: "拉萨市", en: "Lhasa", lng: 91.1145, lat: 29.64415 },
  { cn: "乌鲁木齐市", en: "Urumqi", lng: 87.61688, lat: 43.82663 },
  {
    cn: "香港",
    en: "Hong Kong",
    lng: 114.16546,
    lat: 22.27534,
    label: "right",
  },
  { cn: "澳门", en: "Macau", lng: 113.54913, lat: 22.19875, label: "left" },
];

export const isPC = () => {
  var userAgentInfo = navigator.userAgent;
  var Agents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod",
  ];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
};

class App extends PureComponent {
  state = {
    lang: window.localStorage.getItem("app-lang") === "en" ? "en" : "cn",
    langMenuOpen: false,
    activeImage: 1,
    activeImage2: 1,
    navBarClass: "",
    activePage: 0,
    pageClass: {
      page1: 0,
      page2: 0,
      page3: 0,
      page4: 0,
      page5: 0,
      page6: 0,
      page7: 0,
      page8: 0,
      page9: 0,
      page10: 0,
      page11: 0,
      page12: 0,
    },
  };

  componentDidMount() {
    const { pageClass } = this.state;

    document.title = this.state.lang === "en" ? "Aurigin" : "世纪云安";

    this.swiper1 = new Swiper(".swiper-container1", {
      direction: "vertical",
      slidesPerView: isPC() ? 1 : 2,
      centeredSlides: isPC() ? false : true,
      centeredSlidesBounds: isPC() ? false : true,
      spaceBetween: 0,
      height: window.innerHeight,
      allowTouchMove: isPC() ? false : true,
      updateOnWindowResize: true,
      mousewheel: { thresholdTime: 600, thresholdDelta: 30 },
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 2,
        loadOnTransitionStart: true,
      },
      on: {
        slideChangeTransitionStart: this.handleSlideChange,
      },
    });
    this.swiper2 = new Swiper(".swiper-container2", {
      navigation: {
        nextEl: ".swiper-button-next2",
        prevEl: ".swiper-button-prev2",
      },
      updateOnWindowResize: true,
      autoplay: {
        delay: 5000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
      },
      pagination: { el: ".swiper-pagination", clickable: true },
    });
    this.swiper3 = new Swiper(".swiper-container3", {
      autoplay: true,
      updateOnWindowResize: true,
      navigation: {
        nextEl: ".swiper-button-next3",
        prevEl: ".swiper-button-prev3",
      },
    });
    this.swiper4 = new Swiper(".swiper-container4", {
      autoplay: true,
      updateOnWindowResize: true,
      navigation: {
        nextEl: ".swiper-button-next4",
        prevEl: ".swiper-button-prev4",
      },
    });

    this.initMap(this.state.lang);

    this.changeNavBar(true);
    this.setState({
      pageClass: { ...pageClass, page1: 1 },
    });

    this.video.current.play();

    document.addEventListener("click", this.onDocClick);
  }

  initMap = (lang) => {
    // 语言切换会重建地图场景，旧的异步回调通过序号丢弃
    const seq = (this.mapSeq = (this.mapSeq || 0) + 1);

    if (this.scene) {
      this.scene.destroy();
      this.scene = null;
    }
    const mapEl = document.getElementById("map");
    if (mapEl) {
      mapEl.innerHTML = "";
    }

    const gaodeOptions = {
      pitch: 0,
      style: "dark",
      // 底图语言跟随站点语言：中英文共用同一套原生底图渲染，仅标注语言不同
      lang: lang === "en" ? "en" : "zh_cn",
      center: [104.288144, 31.239692],
      zoom: 4,
      // dragEnable: false, //是否允许地图拖拽
      keyboardEnable: false, // 是否允许形键盘事件
      doubleClickZoom: true, // 双击放大
      zoomEnable: false, // 滚动缩放
      rotateEnable: false, // 旋转
    };

    const scene = new Scene({
      id: "map",
      map: new GaodeMap(gaodeOptions),
    });
    this.scene = scene;

    scene.on("loaded", () => {
      if (seq !== this.mapSeq) return;
      const pointLayer = new PointLayer({})
        .source(launchCities, {
          parser: {
            type: "json",
            x: "lng",
            y: "lat",
          },
        })
        .shape("circle")
        .active(true)
        .animate(true)
        .size(20)
        .color("#f3ffc0")
        .style({
          opacity: 1,
        });
      scene.addLayer(pointLayer);

      if (lang === "en") {
        // 高德英文底图在低 zoom 下只渲染 Hong Kong 的红圈符号、不渲染文字标注，
        // 补一个仿原生样式的文字标注：红圈符号 + 右侧英文城市名，随地图缩放自动跟随。
        // 高德 1.4 对自定义 content 的 Marker 按固定偏移定位（content 左上角 = 投影点 - (9px, 31px)），
        // 故用 translate(5px, 24px) 补偿，使 8px 符号中心精确对准投影坐标。
        const AMapCtor = window.AMap;
        const amap = scene.mapService && scene.mapService.map;
        const hk = launchCities.find((c) => c.en === "Hong Kong");
        if (AMapCtor && amap && hk) {
          const el = document.createElement("div");
          el.style.cssText =
            "position:relative;display:flex;align-items:center;transform:translate(5px,24px);";
          el.innerHTML =
            '<div style="width:8px;height:8px;border-radius:50%;background:#fff;' +
            'border:2px solid #d64137;box-sizing:border-box;flex:none;"></div>' +
            '<div style="margin-left:5px;font-size:12px;line-height:14px;color:#5a6064;' +
            'white-space:nowrap;text-shadow:0 0 2px #fff,0 0 3px #fff,0 0 4px #fff;">Hong Kong</div>';
          new AMapCtor.Marker({
            position: [hk.lng, hk.lat],
            content: el,
            zIndex: 130,
          }).setMap(amap);
        }
      }
    });
  };

  handleSlideChange = (v) => {
    const { pageClass } = this.state;
    const pageName = `page${v.activeIndex + 1}`;
    this.setState({
      pageClass: { ...pageClass, [pageName]: 1 },
      activePage: v.activeIndex,
    });
    if (v.activeIndex === 0) {
      this.changeNavBar(true);
    } else {
      this.changeNavBar();
    }
  };

  changeNavBar = (type) => {
    clearTimeout(this.timer);
    this.setState({
      navBarClass: "show",
    });
    if (!type) {
      this.timer = setTimeout(() => {
        this.setState({
          navBarClass: "",
        });
      }, 3000);
    }
  };

  hideNavBar = () => {
    const { activePage } = this.state;
    if (activePage !== 0) {
      this.setState({
        navBarClass: "",
      });
    }
  };

  toggleLangMenu = () => {
    this.setState((s) => ({ langMenuOpen: !s.langMenuOpen }));
  };

  selectLang = (newLang) => {
    window.localStorage.setItem("app-lang", newLang);
    this.setState({
      lang: newLang,
      langMenuOpen: false,
    });
  };

  // 点击下拉菜单外部时关闭菜单
  onDocClick = (e) => {
    if (
      this.state.langMenuOpen &&
      this.langSwitchRef.current &&
      !this.langSwitchRef.current.contains(e.target)
    ) {
      this.setState({ langMenuOpen: false });
    }
  };

  langSwitchRef = createRef();

  componentWillUnmount() {
    document.removeEventListener("click", this.onDocClick);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.lang !== this.state.lang) {
      document.title = this.state.lang === "en" ? "Aurigin" : "世纪云安";
      // 语言切换后，重新应用已加载的懒加载背景图（swiper 加载后不再响应 data-background 变化）
      this.refreshLazyBackgrounds();
      // 重建地图场景：英文模式隐藏底图中文标注并显示英文城市名
      this.initMap(this.state.lang);
    }
  }

  refreshLazyBackgrounds = () => {
    document.querySelectorAll("[data-background]").forEach((el) => {
      if (el.style.backgroundImage) {
        el.style.backgroundImage = `url("${el.getAttribute("data-background")}")`;
      }
    });
  };

  changeTab = (e, v, type) => {
    e.preventDefault();
    if (type === 2) {
      this.setState({
        activeImage2: v,
      });
    } else {
      this.setState({
        activeImage: v,
      });
    }
  };

  changeSlide = (v) => {
    this.swiper1.slideTo(v);
  };

  video = createRef();

  navApp = () => {
    // 使用相对路径，兼容子路径部署（与 homepage: "." 一致）
    // window.location.href = "./mobile/mobile.html";
  };

  render() {
    const {
      lang,
      langMenuOpen,
      activeImage,
      activeImage2,
      pageClass,
      navBarClass,
    } = this.state;

    // 取当前语言文案
    const t = (word) => word[lang];

    // 取当前语言图片（英文优先 _en 结尾图片）
    const img = (file) => getImage(lang, file);

    const tabListElem = tabList.map((val) => (
      <div
        className={`tab-item ${activeImage === val.tabValue ? "active" : ""}`}
        key={val.tabValue}
        onClick={(e) => this.changeTab(e, val.tabValue)}
      >
        {t(transWord.page11.tabs[val.tabLableKey])}
      </div>
    ));
    const activeImageElem = tabList
      .filter((val) => val.tabValue === activeImage)[0]
      .tabImage.map((val) => <div key={val} className={`image image${val}`} />);

    const tabListElem2 = tabList2.map((val) => (
      <div
        className={`tab-item ${activeImage2 === val.tabValue ? "active" : ""}`}
        key={val.tabValue}
        onClick={(e) => this.changeTab(e, val.tabValue, 2)}
      >
        {t(transWord.page12.tabs[val.tabLableKey])}
      </div>
    ));
    const activeImageElem2 = tabList2
      .filter((val) => val.tabValue === activeImage2)[0]
      .tabImage.map((val) => (
        <div className="image-wrap" key={val.value}>
          <div className={`image image${val.value}`} />
          <div className="desc">
            {val.descKey ? t(transWord.page12.quals[val.descKey]) : val.desc}
          </div>
        </div>
      ));

    // 渲染带高亮片段的段落（page3 业务规模）
    const renderSeg = (seg) =>
      seg[lang].map((s, i) => (s.hl ? <span key={i}>{s.hl}</span> : s.t));

    // 渲染产品参数表（page9 产品介绍）
    const renderSpecTable = (product) => (
      <div className="table-list">
        <div className="table-item head">
          <h3 className="green">{t(product.name)}</h3>
          <p className="green">{t(product.specName)}</p>
        </div>
        {product.rows.map((row, ri) => (
          <div className="table-item" key={ri}>
            {row.map((cell, ci) => (
              <div className="desc" key={ci}>
                <p>{t(cell)}</p>
              </div>
            ))}
          </div>
        ))}
      </div>
    );

    return (
      <div className={`App ${lang === "en" ? "lang-en" : ""}`}>
        <div
          className={`nav-bar ${navBarClass}`}
          onMouseEnter={this.changeNavBar}
          onMouseLeave={this.hideNavBar}
        >
          <div className="wrapper">
            <div className="content">
              <div
                onClick={() => this.changeSlide(0)}
                className="logo image"
                style={{ backgroundImage: `url(${img("logo.png")})` }}
              />
              <ul>
                <li onClick={() => this.changeSlide(1)}>
                  {t(transWord.navBar.li1)}
                </li>
                <li onClick={() => this.changeSlide(5)}>
                  {t(transWord.navBar.li2)}
                </li>
                <li onClick={() => this.changeSlide(8)}>
                  {t(transWord.navBar.li3)}
                </li>
                <li onClick={() => this.changeSlide(10)}>
                  {t(transWord.navBar.li4)}
                </li>
                <li className="lang-switch" ref={this.langSwitchRef}>
                  <div className="lang-current" onClick={this.toggleLangMenu}>
                    {lang === "en" ? "English" : "中文"}
                    <span className="arrow" />
                  </div>
                  {langMenuOpen && (
                    <div className="lang-menu">
                      <div
                        className={lang === "cn" ? "active" : ""}
                        onClick={() => this.selectLang("cn")}
                      >
                        中文
                      </div>
                      <div
                        className={lang === "en" ? "active" : ""}
                        onClick={() => this.selectLang("en")}
                      >
                        English
                      </div>
                    </div>
                  )}
                </li>
                <li>{t(transWord.navBar.li6)}</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="swiper-container swiper-container1">
          <div className="swiper-wrapper">
            {/* 首页 1*/}
            <div className="swiper-slide">
              <div className="swiper-container swiper-container2">
                <div className="swiper-wrapper">
                  <div className="swiper-slide">
                    <div
                      data-background={img("page1Bg.png")}
                      className={`page page1 swiper-lazy image ${
                        pageClass.page1 ? "active" : ""
                      }`}
                    >
                      <div className="swiper-lazy-preloader"></div>
                      <video
                        muted={true}
                        controls={false}
                        ref={this.video}
                        loop
                        poster={img("cover.png")}
                        width="100%"
                        height="100%"
                      >
                        <source src={video2} type="video/mp4" />
                        <p>
                          Your browser doesn't support HTML5 video. Here is a{" "}
                          <a href={video}>link to the video</a> instead.
                        </p>
                      </video>
                      <div className="content">
                        <div className="title1">{t(transWord.page1.w1)}</div>
                        <div className="title2">{t(transWord.page1.w2)}</div>
                        <div className="num-group">
                          <div className="num-item">
                            <div className="num">
                              {pageClass.page1 && (
                                <CountUp
                                  separator=","
                                  start={0}
                                  end={212854529}
                                  duration="3"
                                />
                              )}
                            </div>
                            <div className="title">{t(transWord.page1.w3)}</div>
                          </div>
                          <div className="num-item">
                            <div className="num">
                              {pageClass.page1 && (
                                <CountUp
                                  separator=","
                                  start={0}
                                  end={12303730}
                                  duration="3"
                                />
                              )}
                            </div>
                            <div className="title">{t(transWord.page1.w4)}</div>
                          </div>
                          <div className="num-item">
                            <div className="num">
                              {pageClass.page1 && (
                                <CountUp
                                  separator=","
                                  start={0}
                                  end={168}
                                  duration="3"
                                />
                              )}
                            </div>
                            <div className="title">{t(transWord.page1.w5)}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="swiper-lazy-preloader"></div>
                    <div
                      data-background={img("page1Image2.jpg")}
                      className="page page1 swiper-lazy image"
                    ></div>
                  </div>
                  <div className="swiper-slide">
                    <div className="swiper-lazy-preloader"></div>
                    <div
                      data-background={img("page1Image3.jpg")}
                      className="page page1 swiper-lazy image"
                    ></div>
                  </div>
                  <div className="swiper-slide">
                    <div className="swiper-lazy-preloader"></div>
                    <div
                      data-background={img("page1Image4.jpg")}
                      className="page page1 swiper-lazy image"
                    ></div>
                  </div>
                </div>
                <div className="swiper-pagination"></div>
                <div className="swiper-button-prev swiper-button-prev2"></div>
                <div className="swiper-button-next swiper-button-next2"></div>
              </div>
            </div>
            {/* 关于我们 2*/}
            <div className="swiper-slide">
              <div className={`page page10 ${pageClass.page2 ? "active" : ""}`}>
                <div className="wrapper">
                  <div className="page-title white">
                    <p>{t(transWord.page2.title)}</p>
                    <p>{t(transWord.page2.titleSub)}</p>
                  </div>
                  <div className="content">
                    <div className="up">
                      <div className="video">
                        <video controls width="400px">
                          <source src={video} type="video/mp4" />
                          <p>
                            Your browser doesn't support HTML5 video. Here is a{" "}
                            <a href={video}>link to the video</a> instead.
                          </p>
                        </video>
                      </div>
                      <div className="desc">
                        <div className="desc-title">
                          {t(transWord.page2.companyName)}
                        </div>
                        <div className="desc-detail">
                          {t(transWord.page2.companyDesc)}
                        </div>
                      </div>
                    </div>
                    <div className="down">
                      <div className="time-line-list">
                        {transWord.page2.timeline.map((item) => (
                          <div className="time-line-item" key={t(item.title)}>
                            <div className="item-title">{t(item.title)}</div>
                            <div className="item-desc">
                              {item.items.map((it, i) => (
                                <p key={i}>{t(it)}</p>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* 地图 3*/}
            <div className="swiper-slide">
              <div className={`page page2 ${pageClass.page3 ? "active" : ""}`}>
                <div id="map"></div>
                <div className="content">
                  <div className="page-title">
                    <p>{t(transWord.page3.title)}</p>
                    <p>{t(transWord.page3.titleSub)}</p>
                  </div>
                  <div className="desc">
                    <div className="desc-title">
                      {t(transWord.page3.efficiencyTitle)}
                    </div>
                    <p>{renderSeg(transWord.page3.effP1)}</p>
                    <p>{renderSeg(transWord.page3.effP2)}</p>
                    <p>{t(transWord.page3.effP3)}</p>
                    <p>{t(transWord.page3.effP4)}</p>
                  </div>
                  <div className="desc2">
                    {transWord.page3.stats.map((s, i) => (
                      <div className="desc-item" key={i}>
                        <div className="num">
                          {pageClass.page3 && (
                            <CountUp
                              start={0}
                              end={page3StatNums[i]}
                              duration="3"
                            />
                          )}
                          +
                        </div>
                        <div className="word">{t(s)}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            {/* 战略投资伙伴 4*/}
            <div className="swiper-slide">
              <div className={`page page3 ${pageClass.page4 ? "active" : ""}`}>
                <div
                  data-background={img("page3Bg.png")}
                  className="swiper-lazy up image"
                >
                  <div className="content">
                    <div className="left-title">
                      <div className="title1">
                        {t(transWord.page4.leftTitle1)}
                      </div>
                      <div className="title2">
                        {t(transWord.page4.leftTitle2)}
                      </div>
                      <div className="title3">
                        {t(transWord.page4.leftTitle3)}
                      </div>
                    </div>
                    <div className="right-card">
                      <p>{t(transWord.page4.cardP1)}</p>
                      <p>{t(transWord.page4.cardP2)}</p>
                      <p>{t(transWord.page4.cardP3)}</p>
                      <p>{t(transWord.page4.cardP4)}</p>
                    </div>
                  </div>
                </div>
                <div className="down">
                  <div className="content">
                    <div className="left-word">
                      <div className="title">
                        {t(transWord.page4.visionTitle)}
                      </div>
                      <div className="desc">
                        {t(transWord.page4.visionDesc)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* ENGIE——全球领军企业 5*/}
            <div className="swiper-slide">
              <div className={`page page13 ${pageClass.page5 ? "active" : ""}`}>
                <div className="content">
                  <div className="up">
                    <div className="desc-list">
                      {transWord.page5.items.map((item, idx) => (
                        <div className="desc-item" key={idx}>
                          <div className="title">{t(item.title)}</div>
                          <div className="sub">{t(item.sub)}</div>
                          <div className="word">
                            {item.paras.map((p, i) => (
                              <p key={i}>{t(p)}</p>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="down">
                    <div
                      data-background={img("13-1.png")}
                      className="swiper-lazy image image1"
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* 产品概览 6*/}
            <div className="swiper-slide">
              <div className={`page page5 ${pageClass.page6 ? "active" : ""}`}>
                <div className="wrapper">
                  <div className="page-title">
                    <p>{t(transWord.page6.title)}</p>
                    <p>{t(transWord.page6.titleSub)}</p>
                  </div>
                </div>
                <div className="content">
                  <div
                    data-background={img("page5Image1.png")}
                    className="swiper-lazy image image2"
                  />
                  <div className="word space">
                    {transWord.page6.groups.map((g, gi) => (
                      <div className="word-item" key={gi}>
                        <div className="title">{t(g.title)}</div>
                        <ul>
                          {g.items.map((item, ii) => {
                            // 云端服务产品中的“淘淘充移动端”可跳转 App 介绍页
                            const clickable = gi === 3 && ii === 3;
                            return (
                              <li
                                key={ii}
                                onClick={clickable ? this.navApp : undefined}
                                style={
                                  clickable ? { cursor: "pointer" } : undefined
                                }
                              >
                                {t(item)}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            {/* 智能充电解决方案 7*/}
            <div className="swiper-slide">
              <div className={`page page7 ${pageClass.page7 ? "active" : ""}`}>
                <div className="wrapper2">
                  <div className="page-title">
                    <p>{t(transWord.page7.title)}</p>
                    <p>{t(transWord.page7.titleSub)}</p>
                  </div>
                </div>
                <div className="content">
                  <div
                    data-background={img("page7Image1.png")}
                    className="swiper-lazy desc-list image"
                  >
                    {/* <div className="wrapper">
                      <div className="desc desc1">
                        <div className="s-title">合作伙伴管理平台</div>
                        <ul className="list">
                          <li>站点信息管理</li>
                          <li>设备及用户行为监控</li>
                          <li>计价模型设置</li>
                          <li>用户账户管理</li>
                          <li>对账管理</li>
                          <li>分账管理</li>
                          <li>支付实时到账</li>
                        </ul>
                      </div>
                      <div className="desc desc2">
                        <div className="s-title">移动客户端</div>
                        <ul className="list">
                          <li>远程实时监控充电状态</li>
                          <li>充电桩及车位预约</li>
                          <li>社区充电轻社交</li>
                          <li>充值营销活动</li>
                          <li>故障报修</li>
                        </ul>
                      </div>
                      <div className="desc desc3">
                        <div className="s-title">智能车位管理技术</div>
                        <ul className="list">
                          <li>解决油车占位问题</li>
                          <li>提高充电桩利用率</li>
                          <li>优化车位资源</li>
                          <li>车位状态识别</li>
                        </ul>
                      </div>
                      <div className="desc desc4">
                        <div className="s-title">有序充电</div>
                        <ul className="list">
                          <li>收集和分析用电需求和站点使用情况</li>
                          <li>动态调整和分配充电功率</li>
                          <li>总电容量不变的情况下，可实现充电车位扩容100</li>
                          <li>动态响应电网和智能楼宇系统的限电需求</li>
                          <li>支持容灾保护</li>
                        </ul>
                      </div>
                      <div className="desc desc5">
                        <div className="s-title">充电运营管理平台</div>
                        <ul className="list">
                          <li>站点及计价体系建立</li>
                          <li>设备及车位监控</li>
                          <li>用户账号管理及营销</li>
                          <li>合作伙伴管理及清算</li>
                          <li>运营KPI报表</li>
                        </ul>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
            {/* 产品介绍 8*/}
            <div className="swiper-slide">
              <div className={`page page9 ${pageClass.page8 ? "active" : ""}`}>
                <div className="wrapper">
                  <div className="page-title">
                    <p>{t(transWord.page8.title)}</p>
                    <p>{t(transWord.page8.titleSub)}</p>
                  </div>
                </div>
                <div className="content">
                  <div className="swiper-container swiper-container3">
                    <div className="swiper-wrapper">
                      <div className="swiper-slide">
                        <div className="product-page">
                          {renderSpecTable(transWord.page8.products[0])}
                          <div
                            data-background={img("page9Image1.jpg")}
                            className="swiper-lazy image page9Image1"
                          />
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="product-page">
                          <div
                            data-background={img("page9Image2.jpg")}
                            className="swiper-lazy image page9Image2"
                          />
                          {renderSpecTable(transWord.page8.products[1])}
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="product-page">
                          {renderSpecTable(transWord.page8.products[2])}
                          <div
                            data-background={img("page9Image3.jpg")}
                            className="swiper-lazy image page9Image3"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="swiper-button-prev swiper-button-prev3"></div>
                    <div className="swiper-button-next swiper-button-next3"></div>
                  </div>
                </div>
              </div>
            </div>
            {/* 服务概览 9*/}
            <div className="swiper-slide">
              <div className={`page page4 ${pageClass.page9 ? "active" : ""}`}>
                <div className="wrapper">
                  <div className="page-title">
                    <p>{t(transWord.page9.title)}</p>
                    <p>{t(transWord.page9.titleSub)}</p>
                  </div>
                </div>
                <div className="content">
                  <div className="word">
                    {transWord.page9.services.map((s, i) => (
                      <div className="word-item" key={i}>
                        <div className="title">
                          <span>{i + 1}</span>
                          {t(s.title)}
                        </div>
                        <ul>
                          {s.items.map((item, ii) => (
                            <li key={ii}>{t(item)}</li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                  <div
                    data-background={img("page4Image1.png")}
                    className="swiper-lazy image image1"
                  />
                </div>
              </div>
            </div>
            {/* 案例介绍 10*/}
            <div className="swiper-slide">
              <div className={`page page8 ${pageClass.page10 ? "active" : ""}`}>
                <div className="wrapper">
                  <div className="page-title">
                    <p>{t(transWord.page10.title)}</p>
                    <p>{t(transWord.page10.titleSub)}</p>
                  </div>
                </div>
                <div className="content">
                  <div className="swiper-container swiper-container4">
                    <div className="swiper-wrapper">
                      <div className="swiper-slide">
                        <div className="case-wrap">
                          <div className="left">
                            <div
                              data-background={img("page8Image1.jpeg")}
                              className="swiper-lazy image1 image"
                            >
                              <div className="desc">
                                <div className="desc-title">
                                  {t(transWord.page10.cases[0].title)}
                                </div>
                                {t(transWord.page10.cases[0].desc)}
                              </div>
                            </div>
                          </div>
                          <div className="right">
                            <div
                              data-background={img("page8Image2.jpeg")}
                              className="swiper-lazy image2 image"
                            >
                              <div className="desc">
                                <div className="desc-title">
                                  {t(transWord.page10.cases[1].title)}
                                </div>
                                {t(transWord.page10.cases[1].desc)}
                              </div>
                            </div>
                            <div
                              data-background={img("page8Image3.jpeg")}
                              className="swiper-lazy image3 image"
                            >
                              <div className="desc">
                                <div className="desc-title">
                                  {t(transWord.page10.cases[2].title)}
                                </div>
                                {t(transWord.page10.cases[2].desc)}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="case-wrap">
                          <div className="left">
                            <div
                              data-background={img("page8Image4.jpeg")}
                              className="swiper-lazy image4 image"
                            >
                              <div className="desc">
                                <div className="desc-title">
                                  {t(transWord.page10.cases[3].title)}
                                </div>
                                {t(transWord.page10.cases[3].desc)}
                              </div>
                            </div>
                          </div>
                          <div className="right">
                            <div
                              data-background={img("page8Image5.jpeg")}
                              className="swiper-lazy image5 image"
                            >
                              <div className="desc">
                                <div className="desc-title">
                                  {t(transWord.page10.cases[4].title)}
                                </div>
                                {t(transWord.page10.cases[4].desc)}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="swiper-button-prev swiper-button-prev4"></div>
                    <div className="swiper-button-next swiper-button-next4"></div>
                  </div>
                </div>
              </div>
            </div>
            {/* 合作伙伴 11*/}
            <div className="swiper-slide">
              <div
                className={`page page11 ${pageClass.page11 ? "active" : ""}`}
              >
                <div className="wrapper">
                  <div className="page-title">
                    <p>{t(transWord.page11.title)}</p>
                    <p>{t(transWord.page11.titleSub)}</p>
                  </div>
                  <div className="content">
                    <div className="tab-list">{tabListElem}</div>
                    <div className="active-image">{activeImageElem}</div>
                  </div>
                </div>
              </div>
            </div>
            {/* 企业资质 12*/}
            <div className="swiper-slide">
              <div
                className={`page page12 ${pageClass.page12 ? "active" : ""}`}
              >
                <div className="wrapper">
                  <div className="page-title">
                    <p>{t(transWord.page12.title)}</p>
                    <p>{t(transWord.page12.titleSub)}</p>
                  </div>
                  <div className="content">
                    <div className="tab-list">{tabListElem2}</div>
                    <div
                      className={`active-image ${
                        activeImage2 === 3 ? "patent-layout" : ""
                      }`}
                    >
                      {activeImageElem2}
                    </div>
                  </div>
                </div>
                <div className="bottom">
                  <div className="content">
                    <div className="up">
                      <div className="left">
                        <div className="item">
                          <div
                            onClick={() => this.changeSlide(0)}
                            className="logo image"
                            style={{
                              backgroundImage: `url(${img("logo.png")})`,
                            }}
                          />
                          <div className="desc">
                            {t(transWord.page12.footer.slogan)}
                          </div>
                        </div>
                        <div className="item">
                          <p onClick={() => this.changeSlide(1)}>
                            {t(transWord.navBar.li1)}
                          </p>
                          <p onClick={() => this.changeSlide(3)}>
                            {t(transWord.navBar.p1)}
                          </p>
                        </div>
                        <div className="item">
                          <p onClick={() => this.changeSlide(5)}>
                            {t(transWord.navBar.li2)}
                          </p>
                          <p onClick={() => this.changeSlide(5)}>
                            {t(transWord.navBar.p2)}
                          </p>
                          <p onClick={() => this.changeSlide(6)}>
                            {t(transWord.navBar.p3)}
                          </p>
                          <p onClick={() => this.changeSlide(7)}>
                            {t(transWord.navBar.p4)}
                          </p>
                        </div>
                        <div className="item">
                          <p onClick={() => this.changeSlide(8)}>
                            {t(transWord.navBar.li3)}
                          </p>
                          <p onClick={() => this.changeSlide(8)}>
                            {t(transWord.navBar.p5)}
                          </p>
                          <p onClick={() => this.changeSlide(9)}>
                            {t(transWord.navBar.p6)}
                          </p>
                        </div>
                        <div className="item">
                          <p onClick={() => this.changeSlide(10)}>
                            {t(transWord.navBar.li4)}
                          </p>
                          <p onClick={() => this.changeSlide(11)}>
                            {t(transWord.navBar.p7)}
                          </p>
                        </div>
                      </div>
                      <div className="center">
                        <p>
                          {t(transWord.page12.footer.website)}
                          <span className="green">www.evchong.com</span>
                        </p>
                        <p>
                          {t(transWord.page12.footer.email)}
                          <span className="green">service@evchong.com</span>
                        </p>
                        <p>
                          {t(transWord.page12.footer.hotline)}
                          <span className="green">400-820-6925</span>
                        </p>
                      </div>
                      <div className="right">
                        <div
                          data-background={img("code1.jpg")}
                          className="swiper-lazy code1 image"
                        />
                      </div>

                      {/*<div className="downImg">*/}
                      {/*/!*<a target="_blank" href="https://xyt.xcc.cn/getpcInfo?sn=1559087899188936704&language=CN&certType=8&url=evchong.com">服务器证书</a>*!/*/}
                      {/*<a target="_blank" href="https://xyt.xcc.cn/getpcInfo?sn=1559087899188936704&certType=8&url=evchong.com&language=CN">*/}
                      {/*<img className="img" src="https://program.xinchacha.com/xyt/xcc_small_ssl.png"/>*/}
                      {/*</a>*/}
                      {/*</div>*/}

                      <div className="downImg2">
                        <a
                          className="imga"
                          href="https://xyt.xcc.cn/getpcInfo?sn=1559087899188936704&language=CN&certType=8&url=evchong.com"
                          target="_blank"
                        >
                          <div className="imgdiv"></div>
                          <embed
                            className="imgembed"
                            src="https://program.xinchacha.com/web/1559087899188936704=evchong.com.svg"
                            type="image/svg+xml"
                            pluginspage="//www.adobe.com/svg/viewer/install/"
                          />
                        </a>
                      </div>
                    </div>
                    <div className="down">
                      <a
                        target="_blank"
                        href="https://beian.miit.gov.cn/"
                        rel="noreferrer"
                      >
                        {t(transWord.page12.footer.icp)}
                      </a>{" "}
                      © www.evchong.com All rights reserved.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;
